import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/usb.vue
var o = {
	name: "DtIconUsb",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--usb"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Usb",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M2 9a1 1 0 1 0 .966.741L5.12 7.587l2.194.877a.5.5 0 0 0 .54-.11l1.411-1.412a.5.5 0 0 0 .589-.088l.5-.5a.5.5 0 0 0 0-.708l-.5-.5a.5.5 0 0 0-.708 0l-.5.5a.5.5 0 0 0-.088.589L7.38 7.413l-1.49-.596 3.61-3.61.146.147a.5.5 0 0 0 .828-.196l.5-1.5a.5.5 0 0 0-.632-.632l-1.5.5a.5.5 0 0 0-.196.828l.147.146-5.11 5.11-.596-1.49L4.74 4.466A1.001 1.001 0 0 0 6 3.5a1 1 0 1 0-1.966.259L2.146 5.646a.5.5 0 0 0-.11.54l.877 2.194-.654.654A1.001 1.001 0 0 0 2 9Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=usb.js.map